<template>
  <fullscreen
    v-model="fullscreen"
    :teleport="teleport"
    :page-only="pageOnly"
    style="z-index: 10"
  >
    <div
      class="fullscreen-wrapper"
      :class="fullscreen ? 'fullscreen-wrapper-full' : ''"
    >
      <v-container
        fluid
        style="border: 1px solid black; background-color: white"
        :class="fullscreen ? 'container-full' : ''"
      >
        <v-row justify="end">
          <v-btn small fab dark style="margin-right: 6px" @click="toggleExpand">
            <v-icon>{{
              fullscreen ? "mdi-window-minimize" : "mdi-arrow-expand-all"
            }}</v-icon>
          </v-btn>
        </v-row>
        <svg id="vizTreeV" class="container-border" />
        <div>
          <v-dialog v-model="dialog" width="50%">
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
               <span class="title">Selected Node:</span><span class="ml-1 font-weight-light">{{selectedNodeData.id}}</span>
                
                <v-spacer></v-spacer>
                <v-tooltip top v-model="showTooltipTitle">
                  <template v-slot:activator="{}">
                    <v-btn small text @click="copyTitle">
                      <v-icon color="grey lighten-1">
                        mdi-content-copy
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ toolTipMessageTitle }}</span>
                </v-tooltip>
              </v-card-title>
              <v-tabs v-model="tab" background-color="transparent" grow>
                <v-tab v-for="item in items" :key="item">
                  {{ item }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat min-height="50vh">
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-tooltip top v-model="showTooltip">
                        <template v-slot:activator="{}">
                          <v-btn small text @click="copy">
                            <v-icon color="grey lighten-1" center>
                              mdi-content-copy
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ toolTipMessage }}</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-card-text>
                      <editor
                        v-model="jsonData"
                        @init="initJSONEditor"
                        lang="javascript"
                        theme="chrome"
                        width="100%"
                        height="60vh"
                        :options="options"
                        :key="editorKey"
                      >
                      </editor>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat min-height="50vh">
                    <v-card-text>
                      <ul>
                        <li
                          v-for="(value, name, index) in nodeDataForDisplay"
                          :key="index"
                        >
                          {{ name }} : {{ value }}
                        </li>
                      </ul>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-container>
    </div>
  </fullscreen>
</template>
<script>
import * as d3 from "d3";
import { component } from "vue-fullscreen";
import { aceEditorMixin } from "@/mixins/aceEditorMixin";
import { ExplainUIMixin } from "@/mixins/EXplainUIMixin";
export default {
  name: "Explain-UI",
  mixins: [aceEditorMixin, ExplainUIMixin],
  components: { fullscreen: component },
  props: {
    sourceData: {
      type: Object,
      required: true,
      default: () => ({ name: "Data is not provided" }),
    },
    showExpandIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      fullscreen: false,
      teleport: false,
      pageOnly: true,
      editorKey: 0,
      dialog: false,
      selectedNodeData: {},
      tab: null,
      items: ["Explain", "Details"],
      showTooltip: false,
      showTooltipTitle: false,
      toolTipMessage: "",
      toolTipMessageTitle: "",
      options: {
        readOnly: true,
      },
      jsonData: "",
      reactiveSourceData: this.sourceData,
    };
  },
  computed: {
    nodeDataForDisplay() {
      return {
        ID: this.selectedNodeData.id,
        Name: this.selectedNodeData.name,
        DataType: this.selectedNodeData.dataType,
        Type: this.selectedNodeData.type,
        TreadId: this.selectedNodeData.treadId,
      };
    },
  },
  methods: {
    toggleExpand() {
      this.fullscreen = !this.fullscreen;
      if (this.fullscreen) {
        let elHtml = document.getElementsByTagName("html")[0];
        elHtml.style.overflowY = "hidden";
      } else {
        let elHtml = document.getElementsByTagName("html")[0];
        elHtml.style.overflowY = null;
      }
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(
          JSON.stringify(this.selectedNodeData.explainObject, null, 2)
        );
        this.toolTipMessage = "Copied!";
        this.showTooltip = true;
      } catch (e) {
        this.toolTipMessage = e.message;
        this.showTooltip = true;
      }
      setTimeout(() => {
        this.showTooltip = false;
      }, 500);
    },
    async copyTitle() {
      try {
        await navigator.clipboard.writeText(this.selectedNodeData.id);
        this.toolTipMessageTitle = "Copied!";
        this.showTooltipTitle = true;
      } catch (e) {
        this.toolTipMessageTitle = e.message;
        this.showTooltipTitle = true;
      }
      setTimeout(() => {
        this.showTooltipTitle = false;
      }, 500);
    },
    collapse(d) {
      //this is for default expanding of tree
      // Collapse the node and all it's children
      // const vueInstance = this;
      // if (d.children) {
      //   d._children = d.children;
      //   d._children.forEach(vueInstance.collapse);
      //   d.children = null;
      // }
      if (d.children) {
        if (
          this.bestPath.find(function(d1) {
            return d1 == d.data.uid;
          })
        ) {
          d.children.forEach(this.collapse);
          return;
        }
        d.children.forEach(function(child) {
          child.parent = d;
        });
        d._children = d.children;
        d._children.forEach(this.collapse);
        d.children = null;
      }
    },
    diagonal(s, d) {
      const path = `M ${s.y} ${s.x}
            C ${(s.y + d.y) / 2} ${s.x},
              ${(s.y + d.y) / 2} ${d.x},
              ${d.y} ${d.x}`;

      return path;
    },
    rightCLickF(event, d) {
      event.preventDefault();
      const explainObject = d.data.explainObject;
      this.dialog = true;
      this.selectedNodeData = d.data;
      this.tab = null;
      if (this.isJsonObject(explainObject)) {
        this.jsonData = JSON.stringify(explainObject, null, 2);
      } else {
        this.jsonData = this.reformString(explainObject);
      }
      this.editorKey += 1;
    },
    doCalculationAndDraw() {
      const waitForCalculation = (callBack) => {
        this.getMinMax(this.reactiveSourceData);
        if (typeof callBack === "function") {
          callBack();
        }
      };
      waitForCalculation(this.initilizeSVG());
    },
    initilizeSVG() {
      this.getMinMax(this.reactiveSourceData);
      d3.select("#vizTreeV")
        .select("g")
        .remove();

      const vueInstance = this;
      const margin = { top: 20, left: 90, right: 20, bottom: 10 };

      const clientWidth = window.screen.width;
      const clientHeight = window.screen.height;

      const svg = d3
        .select("#vizTreeV")
        // .attr("viewBox", [-margin.left, -clientHeight / 2, width, height])
        .attr("viewBox", [
          -margin.left,
          -clientHeight / 2,
          clientWidth,
          clientHeight,
        ])
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      const gLink = svg.append("g");
      const gNode = svg.append("g");

      let zoom = d3
        .zoom()
        .on("zoom", (e) => {
          d3.select("svg g").attr("transform", e.transform);
        })
        .on("start", function() {
          document.getElementsByTagName("svg")[0].style.cursor = "grab";
        })
        .on("end", function() {
          document.getElementsByTagName("svg")[0].style.cursor = "default";
        });
      d3.select("svg").call(zoom);

      let i = 0;
      const duration = 650;
      let root = null;

      // declares a tree layout and assigns the size
      const treemap = d3
        .tree()
        .size([clientHeight, clientWidth])
        .nodeSize([105, 150]);

      // Assigns parent, children, height, depth
      root = d3.hierarchy(vueInstance.reactiveSourceData, (d) => {
        return d.children;
      });
      root.x0 = clientHeight / 2;
      root.y0 = 0;
      // Collapse after the second level
      root.children.forEach(vueInstance.collapse);
      // Collapse from third level
      // root.children[0].children.forEach(vueInstance.collapse);
      update(root);

      function update(source) {
        // Assigns the x and y position for the nodes
        const treeData = treemap(root);

        // Compute the new tree layout.
        const nodes = treeData.descendants();
        const links = treeData.descendants().slice(1);

        // Normalize for fixed-depth.
        nodes.forEach((d) => {
          d.y = d.depth * 180;
        });

        // ****************** Nodes section ***************************

        // Update the nodes...
        let node = gNode.selectAll("g.node").data(nodes, (d) => {
          return d.id || (d.id = ++i);
        });

        // Enter any new modes at the parent's previous position.
        let nodeEnter = node
          .enter()
          .append("g")
          .attr("class", "node")
          .attr("node-id", (d) => d.data.id)
          .attr("transform", () => {
            return "translate(" + source.y0 + "," + source.x0 + ")";
          })
          .on("click", click)
          .on("contextmenu", vueInstance.rightCLickF);

        // Add Circle for the nodes
        nodeEnter
          .append("circle")
          .attr("r", 1e-6)
          .attr("class", "node")
          .style("fill", (d) => {
            return d._children ? "#c9e4ff" : "#fff";
          });

        nodeEnter
          .append("rect")
          .attr("class", "rectNode")
          .attr("width", 100)
          .attr("height", 60)
          .attr("x", -50)
          .attr("y", -72)
          .attr("rx", 5)
          .attr("ry", 5)
          .style("fill", (d) => {
            return d.children || d._children ? "#f0f0f0" : "#ffffff";
          })
          .style("stroke", (d) => {
            return d.data.explainObject.duration !== 0 ? "#000000" : "#cfc8c8";
          })
          .style("stroke-width", "1px");

        nodeEnter
          .append("foreignObject")
          .attr("width", 90)
          .attr("height", 50)
          .attr("x", -45)
          .attr("y", -65)
          .attr("cursor", "pointer")
          .append("xhtml:div")
          .style("padding", "2px")
          .style("overflow-wrap", "break-word")
          .html((d) => `<h4 style="font-size: 10px">${d.data.name}</h4>`);

        // UPDATE
        const nodeUpdate = nodeEnter.merge(node);

        // Transition to the proper position for the node
        nodeUpdate
          .transition()
          .duration(duration)
          .attr("transform", (d) => {
            return "translate(" + d.y + "," + d.x + ")";
          });

        // Update the node attributes and style
        nodeUpdate
          .select("circle.node")
          .attr("r", 10)
          .style("fill", (d) => {
            return d._children ? "#c9e4ff" : "#fff";
          })
          .style("stroke-width", () => {
            return "2px";
          })
          .attr("cursor", "pointer");

        nodeUpdate
          .select("rect.rectNode")
          .style("fill", (d) => {
            return d._children ? "#f0f0f0" : "#ffffff";
          })
          .attr("cursor", "pointer");
        // Remove any exiting nodes
        const nodeExit = node
          .exit()
          .transition()
          .duration(duration)
          .attr("transform", () => {
            return "translate(" + source.y + "," + source.x + ")";
          })
          .remove();

        // On exit #f7d708uce the node circles size to 0
        nodeExit.select("circle").attr("r", 1e-6);

        // On exit #f7d708uce the opacity of text labels
        nodeExit.select("text").style("fill-opacity", 1e-6);

        // ****************** links section ***************************

        // Update the links...
        const link = gLink.selectAll("path.link").data(links, (d) => {
          return d.id;
        });

        // Enter any new links at the parent's previous position.
        const linkEnter = link
          .enter()
          .insert("path", "g")
          .attr("class", "link")
          .attr("stroke-width", (d) => {
            const isTypeFilter = d.data.type.localeCompare(
              "filter",
              undefined,
              { sensitivity: "accent" }
            );
            return isTypeFilter === 0
              ? vueInstance.computePathWidth(d.data.explainObject.duration)
              : 1;
          })
          .attr("d", () => {
            const o = { x: source.x0, y: source.y0 };
            return vueInstance.diagonal(o, o);
          });

        // UPDATE
        const linkUpdate = linkEnter.merge(link);

        // Transition back to the parent element position
        linkUpdate
          .transition()
          .duration(duration)
          .attr("stroke-width", (d) => {
            //this part is for taking type as filter into consideration
            // const isTypeFilter = d.data.type.localeCompare(
            //   "filter",
            //   undefined,
            //   { sensitivity: "accent" }
            // );
            // return isTypeFilter === 0
            //   ? vueInstance.computePathWidth(d.data.explainObject.duration)
            //   : 1;
            return vueInstance.computePathWidth(d.data.explainObject.duration);
          })
          .style("stroke", (d) => {
            //this part is for taking type as filter into consideration
            // const isTypeFilter = d.data.type.localeCompare(
            //   "filter",
            //   undefined,
            //   { sensitivity: "accent" }
            // );
            // const pathWidth =
            //   isTypeFilter === 0
            //     ? vueInstance.computePathWidth(d.data.explainObject.duration)
            //     : 1;
            const pathWidth = vueInstance.computePathWidth(
              d.data.explainObject.duration
            );

            return pathWidth >= 5
              ? "#28a745"
              : pathWidth >= 2 && pathWidth < 5
              ? "#007bff"
              : "#dc3545";
          })
          .attr("d", (d) => {
            return vueInstance.diagonal(d, d.parent);
          });

        // Remove any exiting links
        link
          .exit()
          .transition()
          .duration(duration)
          .attr("stroke-width", (d) => {
            //this part is for taking type as filter into consideration
            // const isTypeFilter = d.data.type.localeCompare(
            //   "filter",
            //   undefined,
            //   { sensitivity: "accent" }
            // );
            // return isTypeFilter === 0
            //   ? vueInstance.computePathWidth(d.data.explainObject.duration)
            //   : 1;
            return vueInstance.computePathWidth(d.data.explainObject.duration);
          })
          .style("stroke", (d) => {
            //this part is for taking type as filter into consideration
            // const isTypeFilter = d.data.type.localeCompare(
            //   "filter",
            //   undefined,
            //   { sensitivity: "accent" }
            // );
            // const pathWidth =
            //   isTypeFilter === 0
            //     ? vueInstance.computePathWidth(d.data.explainObject.duration)
            //     : 1;
            const pathWidth = vueInstance.computePathWidth(
              d.data.explainObject.duration);

            return pathWidth >= 5
              ? "#28a745"
              : pathWidth >= 2 && pathWidth < 5
              ? "#007bff"
              : "#dc3545";
          })
          .attr("d", () => {
            const o = { x: source.x, y: source.y };
            return vueInstance.diagonal(o, o);
          })
          .remove();

        // LinkTexts here
        const linkText = gLink.selectAll("g").data(links, (d) => d.id);
        const linkTextEnter = linkText
          .enter()
          .append("g")
          .attr("class", "linkLabel")
          .attr("transform", function() {
            return `translate(${source.y0},${source.x0})`;
          });

        linkTextEnter.append("text").text((d) => d.data.explainObject.duration);
        linkText
          .merge(linkTextEnter)
          .transition()
          .duration(duration)
          .attr(
            "transform",
            (d) =>
              `translate(${(d.parent.y + d.y) / 2},${(d.parent.x + d.x) / 2})`
          )
          // Smooth transition from 0 to 1 and back to 0 when expanding/collapsing
          .attr("fill-opacity", 1)
          .attr("stroke-opacity", 1);
        linkText
          .exit()
          .transition()
          .duration(duration)
          .remove()
          .attr("transform", () => `translate(${source.y},${source.x})`)
          .attr("fill-opacity", 0)
          .attr("stroke-opacity", 0);

        // Store the old positions for transition.
        nodes.forEach((d) => {
          d.x0 = d.x;
          d.y0 = d.y;
        });

        // Toggle children on click.
        function click(e, d) {
          if (d.children) {
            d._children = d.children;
            d.children = null;
          } else {
            d.children = d._children;
            d._children = null;
          }
          update(d);
        }
      }
    },
  },
  watch: {
    sourceData: {
      handler(newVal) {
        this.reactiveSourceData = newVal;
        this.doCalculationAndDraw();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.doCalculationAndDraw();
  },
};
</script>
<style>
#vizTreeV circle {
  fill: #fff;
  stroke: #54a8ff;
}
#vizTreeV .node text {
  font: 12px sans-serif;
}
#vizTreeV .rectNode {
  cursor: pointer;
}
#vizTreeV .link {
  fill: none;
}
.fullscreen-wrapper {
  width: 100%;
  background: #333;
  align-items: center;
  justify-content: center;
}
.fullscreen-wrapper-full {
  height: 100vh;
}
.container-full {
  max-width: 100% !important;
  height: 100vh !important;
}
body {
  overflow-y: hidden !important;
}
.linkLabel {
  font: 16px sans-serif;
  text-anchor: top;
}
</style>
